import { NotificationResponseType } from "constants/types/notification";
import { DEBT_RECEIPT_DETAIL_PAGE } from "routes/route.constant";

export const NOTIFICATION_INITIAL_LIMIT = 7;
export const NOTIFICATION_LIMIT_STEP = 5;

export type NotificationTab = "all" | "unread";

export function resolveNotificationRoute(item: NotificationResponseType): string | null {
  if (item.type === "payment_review" && item.data?.journalId) {
    return DEBT_RECEIPT_DETAIL_PAGE.replace(":id", item.data.journalId as string);
  }
  return null;
}
